/*      Dara - Students
 * All axios endpoints for students. They will be prefixed with /api/myhq-spa/students/
 */
import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'
import type IStudentDetail from '@/interfaces/api-resources/Dara/StudentDetail'
import type IDataResponse from '@/interfaces/api-resources/DataResponse'
import type Interview from '@/models/Interview/Interview'
import type { TimelineTypeFilter } from '@/enums/TimelineTypeFilter'

export default {
  baseUrl() {
    const appStore = useAppStore()

    return `${appStore.daraApiBaseUrl}/students/`
  },

  get(id: number) {
    return axios.get<IDataResponse<Domain.Students.Resources.ApiV3.StudentDetailResource>, IDataResponse<Domain.Students.Resources.ApiV3.StudentDetailResource>>(this.baseUrl() + id)
      .then(data => data.data)
  },

  put(id: number, data: object) {
    return axios.put<IDataResponse<IStudentDetail>, IDataResponse<IStudentDetail>>(this.baseUrl() + id, data)
  },

  addTimelineComment(id: number, data: object) {
    return axios.post(this.baseUrl() + id + '/timeline-comments', data)
  },

  assignLicence(id: number, data: object) {
    return axios.post<IDataResponse<IStudentDetail>, IDataResponse<IStudentDetail>>(`${this.baseUrl()}${id}/licences`, data)
  },

  enableLicencedProgramme(id: number, data: object) {
    return axios.post(`${this.baseUrl()}${id}/programmes`, data)
  },

  getActivities(studentId: number) {
    return axios.get<
      IDataResponse<Domain.Activities.Resources.ApiV3.StudentActivityDetailedResource[]>,
      IDataResponse<Domain.Activities.Resources.ApiV3.StudentActivityDetailedResource[]>
    >(`${this.baseUrl()}${studentId}/activities`)
  },

  getTimelineComments(studentId: number) {
    return axios.get<
      IDataResponse<Domain.Students.Resources.ApiV3.TimelineCommentResource[]>,
      IDataResponse<Domain.Students.Resources.ApiV3.TimelineCommentResource[]>
    >(`${this.baseUrl()}${studentId}/timeline-comments`)
  },

  getUpcomingInterviews(id: number) {
    return axios.get<Interview[]>(`${this.baseUrl()}${id}/upcoming-interviews`)
  },

  getPastInterviews(id: number) {
    return axios.get<Interview[]>(`${this.baseUrl()}${id}/past-interviews`)
  },

  getTimeline(data: object, id: number, filter: TimelineTypeFilter) {
    const filters = Object.fromEntries(
      Object.entries(data),
    )

    return axios.get<Domain.Students.Resources.ApiV3.StudentTimelineResource>(`${this.baseUrl()}${id}/timeline/${filter}?`, { params: filters })
  },

  updateGroupAndSubgroup(id: number, data: object) {
    return axios.post(this.baseUrl() + id + '/groups', data)
  },
}
